import _ToolBar from '../ToolBar.jsx'
import MenuButtonEdit from '../menuButtons/MenuButtonEdit.jsx'
import MenuButtonInsertNode from '../menuButtons/MenuButtonInsertNode.jsx'
import MenuButtonInsertProducts from '../menuButtons/MenuButtonInsertProducts.jsx'
import MenuButtonSaveMap from './MenuButtonSaveMap.jsx'

export default function ToolBar(props) {
    return (
        <_ToolBar {...props}>
            <div></div>

            <div>
                <MenuButtonSaveMap />
                <MenuButtonEdit />
                <MenuButtonInsertNode type="common" />
                <MenuButtonInsertNode type="concept" />
                <MenuButtonInsertNode type="product" />
                <MenuButtonInsertProducts />
            </div>
        </_ToolBar>
    )
}
